// Phase 6.C — 작업일정 탭 layout.
// 시안: design/v3/SchedulePage.jsx + design/v3/SectionNav.jsx:195-201 (SCHEDULE_SECTIONS).
// 좌측 SectionNav (5 항목 + 전체 보기) + 우측 Outlet 구조.
//
// 백엔드 schedule 모델은 Phase 7 (메일·SMS 인프라 + DB 모델) 에서 도입.
// 본 phase 는 시안 layout port + mock data + "Phase 7 활성" 라벨.

import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { PageHeader } from '../../components/chrome';
import {
  SettingsSectionNav,
  type SectionNavItem,
} from '../../components/settings/section-nav';
import { useViewport } from '../../lib/useViewport';
import { ScheduleDayHeader } from './header';

const ITEMS: SectionNavItem[] = [
  { id: 'overview', label: '전체 보기', icon: 'list-checks', sub: '오늘 모든 일정' },
  { id: 'common', label: '공통 일정', icon: 'list-checks', sub: '전 직원 공통' },
  { id: 'morning', label: '오전 작업', icon: 'sun', sub: '점심 영업 준비' },
  { id: 'afternoon', label: '오후 작업', icon: 'moon', sub: '저녁 영업 준비' },
  { id: 'prep', label: '전처리 일정', icon: 'knife', sub: '재고 자동 연결' },
  { id: 'closing', label: '퇴근 체크리스트', icon: 'check-circle', sub: '응답 수신' },
];

const PATH_BY_ID: Record<string, string> = {
  overview: '/schedule',
  common: '/schedule/common',
  morning: '/schedule/morning',
  afternoon: '/schedule/afternoon',
  prep: '/schedule/prep',
  closing: '/schedule/closing',
};

function activeFromPath(pathname: string): string {
  if (pathname.startsWith('/schedule/common')) return 'common';
  if (pathname.startsWith('/schedule/morning')) return 'morning';
  if (pathname.startsWith('/schedule/afternoon')) return 'afternoon';
  if (pathname.startsWith('/schedule/prep')) return 'prep';
  if (pathname.startsWith('/schedule/closing')) return 'closing';
  return 'overview';
}

function sectionIdFromPath(pathname: string): string | undefined {
  const a = activeFromPath(pathname);
  return a === 'overview' ? undefined : a;
}

export function ScheduleLayout() {
  const location = useLocation();
  const navigate = useNavigate();
  const active = activeFromPath(location.pathname);
  const sectionId = sectionIdFromPath(location.pathname);
  const viewport = useViewport();
  const isMobile = viewport === 'mobile';

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
      <div style={{ marginLeft: isMobile ? -14 : -24, marginRight: isMobile ? -14 : -24 }}>
        <PageHeader
          viewport={isMobile ? 'mobile' : 'desktop'}
          title="작업일정"
          date="오늘"
        >
          <span />
        </PageHeader>
      </div>
      {/* 시안 DayHeader — sub-route 별 title/sub 분기 */}
      <ScheduleDayHeader sectionId={sectionId} />
      <div
        style={{
          // Phase 6.C-5 — 모바일 stack
          display: 'grid',
          gridTemplateColumns: isMobile ? '1fr' : '240px 1fr',
          gap: isMobile ? 12 : 20,
          alignItems: 'start',
        }}
      >
        <SettingsSectionNav
          items={ITEMS}
          current={active}
          onSelect={(id) => {
            const to = PATH_BY_ID[id];
            if (to) navigate(to);
          }}
          title="작업일정"
        />
        <div style={{ minWidth: 0 }}>
          <Outlet />
        </div>
      </div>
    </div>
  );
}
